import { action, observable } from 'mobx';
import { addToMap } from './Array';
import { bind } from './Bind';
import { HttpClient } from './HttpClient';

export class TooltipsStore {
    public constructor(httpClient: HttpClient) {
        this.httpClient = httpClient;
    }

    @action
    public async loadTooltipsForSubjectAsync(subject: string) {
        const tooltips = await this.httpClient.get<Mri.Tooltips.TooltipModel[]>(`/api/v1/tooltips/${subject}`, {
            cache: true,
        });

        addToMap(this.tooltips, tooltips, t => t.id);
    }

    @bind
    public getTooltip(subject: string, name: string) {
        return this.tooltips.get(subject + '.' + name);
    }

    @observable
    public tooltips = new Map<string, Mri.Tooltips.TooltipModel>();

    private readonly httpClient: HttpClient;
}
